<template>
  <footer class="pl-4 pr-4 pb-4"><!-- update 230412 - p-6 -->
    <slot />
  </footer>
</template>
